/* eslint no-unused-vars: ['error', { 'varsIgnorePattern': 'slick' }] */
import slick from 'slick-carousel';

export default () => {

  const $tabContentSlider = $('.tab-content-slider');

  if ($tabContentSlider.length) {

    $tabContentSlider.map((index, el) => {
      $(el).attr('data-carousel-id', index);

      const $slider = $('.tab-content-slider[data-carousel-id="' + index + '"]');

      $slider.find('.tab-content-slides').slick({
        dots: false,
        infinite: true,
        nextArrow: $slider.find('.tab-content-slider-nav-next'),
        prevArrow: $slider.find('.tab-content-slider-nav-prev')
      });

    });

  }

};
